
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCalculationTemplateGroupDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      